import * as React from 'react';

import {ReadOnlyText} from 'shells/sms-campaigns/read-only-text';
import {Body} from 'shells/typography/body';

import type {SmsDripEditionFragment as SmsDripEdition} from 'nutshell-graphql-types';

import {CharacterCountActionBox, LinkActionBox} from '../../../editions/edition-action-boxes';

type Props = {
    selectedEdition: SmsDripEdition;
};

export function SmsDripEditionPreview(props: Props) {
    return (
        <div className='flex flex-dir-col gap-32'>
            <div>
                <div className='mb-8'>
                    <Body isBold={true}>Text message</Body>
                </div>
                <ReadOnlyText
                    message={props.selectedEdition.content}
                    includeIcon={false}
                    backgroundColor='white'
                    isFullWidth={true}
                />
            </div>
            <div className='flex flex-dir-col gap-8 justify-center'>
                <CharacterCountActionBox
                    content={props.selectedEdition.content}
                    htmlUrlPath={props.selectedEdition.htmlUrlPath}
                />
                {/* @ts-expect-error */}
                <LinkActionBox hasShortLink={props.selectedEdition.hasShortLink} />
            </div>
        </div>
    );
}
